exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Quiz{width:100%}.Quiz .quiz-tabs{width:100%;max-width:1120px;margin:0}.Quiz .quiz-tabs .ant-tabs-bar{margin:0}.Quiz .quiz-tabs .create-dialog-form{background:#fff;padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Quiz/style.scss
// module id = 5024
// module chunks = 0